(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"]) return;
  try {
    
  if (!customElements.get('collection-description')) {
    class CollectionDescription extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        const content = this.querySelector('.collection-description');
        const button = this.querySelector('.read-more-button');

        if (!content) return;

        const style = window.getComputedStyle(content);
        let lineHeight = parseFloat(style.lineHeight);
        const fontSize = parseFloat(style.fontSize);

        if (isNaN(lineHeight)) lineHeight = fontSize * 1.5;

        const maxHeight = lineHeight * 3;
        const collapsedHeight = maxHeight + 2;
        const overflowTolerance = 1;
        const fullHeight = content.scrollHeight;

        content.style.setProperty('--collection-description-collapsed-height', `${collapsedHeight}px`);

        if (fullHeight <= maxHeight + overflowTolerance) {
          this.classList.add('is-short');
        } else {
          this.classList.add('has-read-more');
          if (button) {
            button.addEventListener('click', () => {
              this.classList.toggle('expanded');
            });
          }
        }

        this.setAttribute('data-initialised', 'true');
      }
    }

    customElements.define('collection-description', CollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileOnly = window.matchMedia('(max-width: 768px)');
  let announcement = '';
  if (mobileOnly.matches) {
    announcement = document.querySelector('.announcement-bar-mobile');
  } else {
    announcement = document.querySelector('.announcement-bar-desktop');
  }

  (function () {
    var header = document.querySelector('header.site-header');
    var root = document.querySelector(':root');
    header && root && root.style.setProperty('--header-height', header.offsetHeight + 'px');
    announcement && root && root.style.setProperty('--announcement-bar-height', announcement.offsetHeight + 'px');

    function reCalculate() {
      let mobileOnly = window.matchMedia('(max-width: 768px)');
      let announcement = '';
      if (mobileOnly.matches) {
        announcement = document.querySelector('.announcement-bar-mobile');
      } else {
        announcement = document.querySelector('.announcement-bar-desktop');
      }
      var header = document.querySelector('header.site-header');
      var root = document.querySelector(':root');
      header && root && root.style.setProperty('--header-height', header.offsetHeight + 'px');
      announcement && root && root.style.setProperty('--announcement-bar-height', announcement.offsetHeight + 'px');
    }

    window.addEventListener(
      'resize',
      function () {
        return requestAnimationFrame(reCalculate);
      },
      true
    );

    reCalculate();
  })();

  (function () {
    const header = document.querySelector('header.site-header');
    const announcementBar = document.querySelector('.announcement-bar');

    if (!header) return;

    const headerHeight = header.offsetHeight;
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

    const setBodyPadding = function () {
      var height = headerHeight;
      if (announcementHeight) {
        height = announcementBar.offsetHeight + headerHeight;
      }
      document.body.style.paddingTop = height + 'px';
    };

    const removeBodyPadding = function () {
      document.body.style.paddingTop = '';
    };

    const onScroll = function () {
      if (window.scrollY > announcementHeight) {
        document.body.classList.add('header-fixed');
        return setBodyPadding();
      }

      document.body.classList.remove('header-fixed');
      removeBodyPadding();
    };

    document.querySelectorAll('.site-header--tools__search summary').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!el.parentElement.hasAttribute('open'))
          return document.querySelector('body').classList.add('header-search-fixed');

        document.querySelector('body').classList.remove('header-search-fixed');
      });
    });

    document.querySelectorAll('.site-header--tools__search').forEach(function (searchDetails) {
      searchDetails.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!searchDetails.hasAttribute('open')) return;

        event.preventDefault();
        var summary = searchDetails.querySelector('summary');
        if (summary) {
          summary.click();
          summary.focus();
        }
      });
    });

    document.addEventListener('scroll', onScroll);
  })();

  // Desktop megamenu keyboard handling (Disclosure pattern)
  (function () {
    var desktopMediaQuery = window.matchMedia('(min-width: 64rem)');
    var navigation = document.querySelector('nav.site-header--navigation');

    if (!navigation) return;

    var navButtons = Array.prototype.slice
      .call(
        navigation.querySelectorAll(
          '.site-header--navigation__dropdown-trigger > button.site-header--navigation__list-item'
        )
      )
      .filter(function (button) {
        return !button.closest('.site-header--navigation__mobile-menu');
      });

    if (!navButtons.length) return;

    function getTrigger(button) {
      return button.closest('.site-header--navigation__dropdown-trigger');
    }

    function getDropdown(button) {
      var trigger = getTrigger(button);
      return trigger ? trigger.querySelector('.site-header--navigation__dropdown-content') : null;
    }

    function getFocusableLinks(dropdown) {
      if (!dropdown) return [];
      return Array.prototype.slice.call(dropdown.querySelectorAll('a[href]'));
    }

    function setDropdownLinkTabState(dropdown, isOpen) {
      getFocusableLinks(dropdown).forEach(function (link) {
        if (isOpen) {
          link.removeAttribute('tabindex');
          link.removeAttribute('aria-hidden');
        } else {
          link.setAttribute('tabindex', '-1');
          link.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function closeMenu(button, returnFocus) {
      var trigger = getTrigger(button);
      var dropdown = getDropdown(button);

      if (!trigger || !dropdown) return;

      trigger.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('aria-expanded', 'false');
      dropdown.style.opacity = '';
      dropdown.style.transform = '';
      dropdown.style.pointerEvents = '';
      dropdown.style.zIndex = '';
      setDropdownLinkTabState(dropdown, false);

      if (returnFocus) button.focus();
    }

    function closeAllMenus(exceptButton) {
      navButtons.forEach(function (button) {
        if (exceptButton && button === exceptButton) return;
        closeMenu(button, false);
      });
    }

    function openMenu(button, moveFocusToFirstLink) {
      var trigger = getTrigger(button);
      var dropdown = getDropdown(button);

      if (!trigger || !dropdown) return;

      closeAllMenus(button);

      trigger.classList.add('active');
      trigger.classList.remove('menu-hidden');
      button.setAttribute('aria-expanded', 'true');
      dropdown.setAttribute('aria-expanded', 'true');
      dropdown.style.opacity = '1';
      dropdown.style.transform = 'translateY(0)';
      dropdown.style.pointerEvents = 'initial';
      dropdown.style.zIndex = '1';
      setDropdownLinkTabState(dropdown, true);

      if (!moveFocusToFirstLink) return;

      var links = getFocusableLinks(dropdown);
      if (links.length) links[0].focus();
    }

    function isOpen(button) {
      return button.getAttribute('aria-expanded') === 'true';
    }

    function initMenuState() {
      navButtons.forEach(function (button) {
        button.setAttribute('aria-haspopup', 'true');
        button.setAttribute('aria-expanded', 'false');
        closeMenu(button, false);
      });
    }

    navButtons.forEach(function (button) {
      var dropdown = getDropdown(button);
      var trigger = getTrigger(button);

      if (!dropdown || !trigger) return;

      button.addEventListener('click', function (event) {
        if (!desktopMediaQuery.matches) return;

        event.preventDefault();

        if (isOpen(button)) {
          closeMenu(button, false);
          return;
        }

        openMenu(button, false);
      });

      button.addEventListener('keydown', function (event) {
        if (!desktopMediaQuery.matches) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openMenu(button, true);
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(button, true);
        }
      });

      trigger.addEventListener('mouseenter', function () {
        if (!desktopMediaQuery.matches) return;
        closeAllMenus();
      });

      dropdown.addEventListener('keydown', function (event) {
        if (!desktopMediaQuery.matches) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(button, true);
          return;
        }

        if (event.key !== 'Tab') return;

        var links = getFocusableLinks(dropdown);
        if (!links.length) return;

        var firstLink = links[0];
        var lastLink = links[links.length - 1];

        if (!event.shiftKey && document.activeElement === lastLink) {
          closeMenu(button, false);
          return;
        }

        if (event.shiftKey && document.activeElement === firstLink) {
          event.preventDefault();
          closeMenu(button, true);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!desktopMediaQuery.matches) return;
      if (navigation.contains(event.target)) return;
      closeAllMenus();
    });

    window.addEventListener('resize', function () {
      if (!desktopMediaQuery.matches) closeAllMenus();
    });

    initMenuState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-like-and-viewed"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
